import React, { FC, useContext } from 'react';

import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Close from '@mui/icons-material/Close';

import { ChillerLogsContext } from '../contexts/ChillerLogsContext';
import { ChillerLogPhoto } from '../../model';

interface PhotoThumbnailProps {
  chillerLogPhoto?: ChillerLogPhoto;
}

const PhotoThumbnail: FC<PhotoThumbnailProps> = (props) => {
  let { chillerLogPhoto } = props;

  let { setPhotoDeleteConfirmationModalOpen, setPhotoToDelete } = useContext(ChillerLogsContext);

  const handleXClicked = () => {
    setPhotoDeleteConfirmationModalOpen(true);
    setPhotoToDelete(chillerLogPhoto);
  };

  return (
    <Grid
      item
      key={`chiller-log-photo-${chillerLogPhoto?.id}`}
      xs={4}
      sm={3}
      md={2}
      style={{ position: 'relative', minHeight: 100 }}
    >
      <img
        src={chillerLogPhoto?.file_url}
        alt={`Uploaded ${chillerLogPhoto?.id}`}
        style={{ width: '100%', height: 'auto', borderRadius: 5 }}
        onError={(e) => {
          console.error(`Failed to load image: ${chillerLogPhoto?.file_url}`);
          e.currentTarget.style.display = 'none';
        }}
      />
      <IconButton
        onClick={handleXClicked}
        style={{
          position: 'absolute',
          top: 5,
          right: 0,
          background: 'rgba(0, 0, 0, 0.6)',
          color: 'white',
        }}
        size="small"
      >
        <Close fontSize="small" />
      </IconButton>
    </Grid>
  );
};

export default PhotoThumbnail;
